export const PermissionMaterials = {
    PUT: "mgr-material-**-PUT",
    POST: "mgr-material-POST",
    DELETE: "mgr-material-**-DELETE",
    GET: "mgr-material-GET",
    GET_UUID: "mgr-material-**-GET"
};